"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.inputPropTypes = exports["default"] = void 0;
var _propTypes = _interopRequireDefault(require("prop-types"));
var _react = _interopRequireWildcard(require("react"));
var _automationHooks = require("@airportlabs/automation-hooks");
var _styledComponents = require("styled-components");
var InputParts = _interopRequireWildcard(require("./InputParts"));
var _GhostIconButton = _interopRequireDefault(require("../Buttons/GhostIconButton"));
var _helpers = require("../helpers");
var _excluded = ["component", "type", "clearAfterEnter", "enterKeyPress", "onKeyPress", "unfocusAfterEnter", "onChange", "initialValue", "value", "forwardedRef", "onClear", "renderLeft", "renderRight", "withClearButton", "w", "width", "disabled", "automationHook"];
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }
function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
var inputPropTypes = {
  /**
   * Name for the input field
   */
  name: _propTypes["default"].string,
  /**
   * Input field type
   */
  type: _propTypes["default"].string,
  /**
   * Placeholder text value
   */
  placeholder: _propTypes["default"].string,
  /**
   * Initial value for the field
   */
  initialValue: _propTypes["default"].string,
  /**
   * Id for input component
   */
  id: _propTypes["default"].string,
  /**
   * Function triggered when the field value changes; Receives the event as argument
   */
  onChange: _propTypes["default"].func,
  /**
   * A function to perform when the clear button is clicked; Receives the event as argument
   */
  onClear: _propTypes["default"].func,
  /**
   * Function triggered when the 'Enter' key is pressed
   */
  enterKeyPress: _propTypes["default"].func,
  /**
   * Function triggered when Any key is pressed
   */
  onKeyPress: _propTypes["default"].func,
  /**
   * Clear value after 'Enter' key is pressed
   */
  clearAfterEnter: _propTypes["default"].bool,
  /**
   * Unfocus the field after 'Enter' key is pressed
   */
  unfocusAfterEnter: _propTypes["default"].bool,
  /**
   * When 'true' add the clear button
   */
  withClearButton: _propTypes["default"].bool,
  /**
   * Input component to be used for the input
   */
  component: _propTypes["default"].any,
  /**
   * Value for the field, to make it a controlled field
   */
  value: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].number]),
  /**
   * A ref value to be added on the rendered `input` field
   */
  forwardedRef: _propTypes["default"].any,
  /**
   * A valid css string for the width prop
   */
  w: _propTypes["default"].string,
  /**
   * DEPRECATED: A valid css string for the width prop
   */
  width: _propTypes["default"].string,
  /**
   * Variant for the input
   * TODO: consider renaming default to "border"
   */
  variant: _propTypes["default"].oneOf(["border", "filled", "activeFilled"]),
  /**
   * When true, the field is required - required styling will be applied
   */
  isRequired: _propTypes["default"].bool,
  /**
   * Function used to render the icon (or similar) on the left
   */
  renderLeft: _propTypes["default"].func,
  /**
   * Function used to render the icon (or similar) on the right
   */
  renderRight: _propTypes["default"].func,
  /** Whether the input should be disabled */
  disabled: _propTypes["default"].bool,
  /** Hook used with suffix "clear-button" for automation testing. */
  automationHook: _propTypes["default"].string,
  /** Prop to make the input look like it's glued to something. Will remove the rounded corners and the border on the glued side */
  glued: _propTypes["default"].oneOf(["left", "right", "horizontal"])
};
exports.inputPropTypes = inputPropTypes;
var Input = function Input(_ref) {
  var component = _ref.component,
    _ref$type = _ref.type,
    type = _ref$type === void 0 ? "text" : _ref$type,
    clearAfterEnter = _ref.clearAfterEnter,
    enterKeyPress = _ref.enterKeyPress,
    _onKeyPress = _ref.onKeyPress,
    unfocusAfterEnter = _ref.unfocusAfterEnter,
    onChange = _ref.onChange,
    initialValue = _ref.initialValue,
    value = _ref.value,
    forwardedRef = _ref.forwardedRef,
    onClear = _ref.onClear,
    renderLeft = _ref.renderLeft,
    renderRight = _ref.renderRight,
    withClearButton = _ref.withClearButton,
    w = _ref.w,
    width = _ref.width,
    disabled = _ref.disabled,
    automationHook = _ref.automationHook,
    otherInputProps = _objectWithoutProperties(_ref, _excluded);
  (0, _helpers.useDeprecate)({
    width: width
  }, "Input");
  var isControlled = typeof value !== "undefined";
  var _useState = (0, _react.useState)(initialValue || ""),
    _useState2 = _slicedToArray(_useState, 2),
    text = _useState2[0],
    setText = _useState2[1];
  var showClearButton = withClearButton && (text !== "" || isControlled && value !== "");
  var Component = component !== null && component !== void 0 ? component : InputParts.StyledInput;
  var theme = (0, _styledComponents.useTheme)();
  var changeHandler = function changeHandler(event) {
    event.persist();
    if (!isControlled) {
      setText(event.target.value);
    }
    onChange === null || onChange === void 0 ? void 0 : onChange(event);
  };
  var clearHandler = function clearHandler(event) {
    event.preventDefault();
    if (!isControlled) {
      setText("");
    }
    onClear === null || onClear === void 0 ? void 0 : onClear(event);
    event.target.blur();
  };
  var onEnterKeyPressHandler = function onEnterKeyPressHandler(event) {
    event.preventDefault();
    enterKeyPress === null || enterKeyPress === void 0 ? void 0 : enterKeyPress(event);
    if (clearAfterEnter) {
      if (!isControlled) {
        setText("");
      }
      onClear === null || onClear === void 0 ? void 0 : onClear();
    }
    if (unfocusAfterEnter) {
      event.target.blur();
    }
  };
  return /*#__PURE__*/_react["default"].createElement(InputParts.Wrapper, {
    w: w || width
  }, !!renderLeft && /*#__PURE__*/_react["default"].createElement(InputParts.IconWrapper, {
    side: "left",
    hasRenderLeft: true,
    disabled: disabled
  }, renderLeft()), /*#__PURE__*/_react["default"].createElement(Component, _extends({
    variant: theme.fields.inputVariant /* can be overridden */
  }, otherInputProps, {
    value: isControlled ? value : text,
    onKeyPress: function onKeyPress(event) {
      if (event.key === "Enter") {
        onEnterKeyPressHandler(event);
      }
      _onKeyPress === null || _onKeyPress === void 0 ? void 0 : _onKeyPress(event);
    },
    onChange: changeHandler,
    disabled: disabled,
    type: type,
    ref: forwardedRef,
    iconsCountLeft: 0 + !!renderLeft,
    iconsCountRight: 0 + !!renderRight + !!showClearButton
  }, (0, _automationHooks.hook)(automationHook))), (showClearButton || !!renderRight) && /*#__PURE__*/_react["default"].createElement(InputParts.IconWrapper, {
    side: "right",
    disabled: !renderRight && disabled,
    hasRenderRight: !!renderRight
  }, !disabled && showClearButton && /*#__PURE__*/_react["default"].createElement(InputParts.PointerEventsReset, null, /*#__PURE__*/_react["default"].createElement(_GhostIconButton["default"], _extends({
    name: "Clearclose",
    label: "Clear",
    onClick: clearHandler,
    color: "inputButton",
    p: !!renderRight ? "xxs" : "xs"
  }, (0, _automationHooks.hook)((0, _automationHooks.getHook)(automationHook, "clear-button"))))), renderRight === null || renderRight === void 0 ? void 0 : renderRight()));
};
Input.propTypes = inputPropTypes;
var _default = Input;
exports["default"] = _default;